// extracted by mini-css-extract-plugin
export default {"wrapper":"signUp_wrapper__QRTRW","back":"signUp_back__-nv8g","header":"signUp_header__+rwsh"};